const periodDateOptions: Intl.DateTimeFormatOptions = {
  month: "short",
  year: "numeric",
}

export { periodDateOptions }
